function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import { color, css, transition, StyleSheet } from "../../../styles/theme";
import { Z_DEPTH_SHADOWS } from "../../../constants/sharedConstants";
import { compose, setDisplayName, withContext } from 'recompose';
var CONFIG = {
  border: "1px solid ".concat(color.divider),
  boxShadow: Z_DEPTH_SHADOWS[1],
  boxShadowHover: Z_DEPTH_SHADOWS[2],
  darkThemeBackground: color.black
};
var styles = StyleSheet.create({
  Card: {
    position: 'relative',
    width: '100%',
    transition: transition.easeOut(),
    borderRadius: 3,
    overflow: 'hidden'
  },
  cardBorder: {
    border: CONFIG.border
  },
  cardShadow: {
    boxShadow: CONFIG.boxShadow
  },
  cardDarkTheme: {
    color: color.white,
    backgroundColor: CONFIG.darkThemeBackground
  },
  active: {
    boxShadow: CONFIG.boxShadowHover
  }
});
function getInteractiveStyle(showBorder) {
  var activeStyle = {
    boxShadow: showBorder ? 'none' : CONFIG.boxShadow
  };
  return StyleSheet.create({
    cardInteractive: {
      'cursor': 'pointer',
      ':hover': {
        boxShadow: CONFIG.boxShadowHover
      },
      ':active': activeStyle
    }
  });
}
function Card(_ref) {
  var isActive = _ref.isActive,
    children = _ref.children,
    htmlAttributes = _ref.htmlAttributes,
    isInteractive = _ref.isInteractive,
    isThemeDark = _ref.isThemeDark,
    rootClassName = _ref.rootClassName,
    showBorder = _ref.showBorder,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", _extends({
    style: style
  }, css(rootClassName, styles.Card, showBorder && styles.cardBorder, !showBorder && styles.cardShadow, isInteractive && getInteractiveStyle(showBorder).cardInteractive, isThemeDark && styles.cardDarkTheme, isActive && styles.active), htmlAttributes), children);
}
export default compose(setDisplayName('CardHOC'), withContext({
  isThemeDark: PropTypes.bool
}, function (props) {
  return {
    isThemeDark: props.isThemeDark
  };
}))(Card);